import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import InputLegend from "../../helpers/InputLegend";
import InputTextArea from "../../helpers/InputTextArea";
import InputColor from "../../helpers/InputColor";
import InputCombo from "../../helpers/InputCombo";
import InputInteger from "../../helpers/InputInteger";
import InputTime from "../../helpers/InputTime";
import InputDate from "../../helpers/InputDate";



export default function Kids(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        d_imie_nazwisko: '',
      
        
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


      const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko niewidoczne w dzienniku',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);


     const [errTab, setErrTab] = useState([]);  //z info od serwera.. 


     const defRow = {
          men_dziennik_id: props.id,
          p_dziecko_id: -1,
          imie: '',
          nazwisko:'',
          pokaz: 0,
          nr_w_dzienniku: -1,
          godzina_od: '',
          godzina_do: '',
          sniadanie: 0,
          obiad: 0,
          podwieczorek: 0,
          ktory_rok_w_przedszkolu: '',
          data_wypisana: '',
          przyczyna_wypisania: '',
          uwagi: '',
          forma_nauczania: '',
       };

     const [row, setRowX] = useState(defRow);

    
    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const changeView = (e ) => {

       
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });

        if(v != 'edit')
        {
            setRowX(defRow);
        }
    


    }



       const valChangeListenerRow = (filedName, val, correct, msg) => {         
             console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                        
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        }   


    
    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
 
       
            setFilterParam({
 
               men_dziennik_id: props.id,
               d_imie_nazwisko: '',                
                        

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }




 
    const getTab = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,kids', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);             

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }




     const saveData = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,kid_update', {
                method: 'POST', 
                body: JSON.stringify(row), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            getTab();             
                            setRowX(defRow);
                            setView({v:"list",id:-1});
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }



   if(tab == null)
   {
      setTab([]);
      getTab(); 
      return <div>...</div>
   }



    var viewDialog = null;
    if(view.v == "edit")
    {

        if(row.p_dziecko_id < 0)
        {
            var findInx = -1;

            for(var kk=0;kk<tab.length; kk++)
            {
                if(tab[kk].id == view.id)
                {
                    findInx = kk;break;
                }
            }


            setRowX({
                    men_dziennik_id: props.id,
                    p_dziecko_id: tab[findInx].id,
                    imie: tab[findInx].imie,
                    nazwisko:tab[findInx].nazwisko,
                    pokaz: tab[findInx].pokaz,
                    nr_w_dzienniku: tab[findInx].nr_w_dzienniku,
                    godzina_od: tab[findInx].godzina_od,
                    godzina_do: tab[findInx].godzina_do,
                    sniadanie: tab[findInx].sniadanie,
                    obiad: tab[findInx].obiad,
                    podwieczorek: tab[findInx].podwieczorek,
                    ktory_rok_w_przedszkolu: tab[findInx].ktory_rok_w_przedszkolu,
                    data_wypisana: tab[findInx].data_wypisana,
                    przyczyna_wypisania: tab[findInx].przyczyna_wypisania,
                    uwagi: tab[findInx].uwagi,
                    forma_nauczania: tab[findInx].forma_nauczania,
                });
        }


        var itemsTakNie = [
            {v: 0, title:'Nie'},
            {v: 1, title:'Tak'},
        ];


                viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                                    <div className="dlg_title">
                                       {row.imie} {row.nazwisko}
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                
                                                             

                                                            <div className="form_control">
                                                                <div className="fieldName">Dziecko widoczne w dzienniku</div>
                                                                <InputCombo items={itemsTakNie}   userData={props.userData} value={row.pokaz} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="pokaz" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Nr w dzienniku</div>
                                                                <InputInteger     userData={props.userData} value={row.nr_w_dzienniku} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="nr_w_dzienniku" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>

                                                             <div className="form_control">
                                                                <div className="fieldName">Który rok w przedszkolu</div>
                                                                <InputInteger     userData={props.userData} value={row.ktory_rok_w_przedszkolu} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="ktory_rok_w_przedszkolu" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>


                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Kwalifikacja, od godziny</div>
                                                                <InputTime     userData={props.userData} value={row.godzina_od} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_od" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                             <div className="form_control">
                                                                <div className="fieldName">Kwalifikacja, do godziny</div>
                                                                <InputTime     userData={props.userData} value={row.godzina_do} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="godzina_do" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Śniadanie</div>
                                                                <InputCombo items={itemsTakNie}   userData={props.userData} value={row.sniadanie} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="sniadanie" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                             <div className="form_control">
                                                                <div className="fieldName">Obiad</div>
                                                                <InputCombo items={itemsTakNie}   userData={props.userData} value={row.obiad} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="obiad" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                               <div className="form_control">
                                                                <div className="fieldName">Podwieczorek</div>
                                                                <InputCombo items={itemsTakNie}   userData={props.userData} value={row.podwieczorek} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podwieczorek" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Uwagi* (min. 10 znaków)</div>
                                                                <InputTextArea   userData={props.userData} value={row.uwagi} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="uwagi" placeholder={"Uwagi:"} className=' w400  h50' req='0' firstUp="0" />
                                                            </div>


                                                             <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Data wypisana</div>
                                                                <InputDate     userData={props.userData} value={row.data_wypisana} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="data_wypisana" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Przyczyna wypisana</div>
                                                                <InputText    userData={props.userData} value={row.przyczyna_wypisania} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="przyczyna_wypisania" placeholder={""} className='w400 ' req='0' firstUp="0" />
                                                            </div>



                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>zapisz</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }




        return <div>


                    <div className="table_filter">

                        <div className="filter_controll">   
                            <label>Imię i nazwisko: </label>                             
                            <InputText   userData={props.userData}  mainView={props.mainView}   value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Imię i nazwisko: "}     />
                        </div>

                        <div className="filter_btn">                           
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                    </div>


                      <div className="table_widget">    
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />  
                      </div>


                    <div ref={tabRef} className="gohide">
                        <h3>{props.title}</h3>   

                          <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Nr w dzienniku</td>                                                     
                                                    <td className="">Imię i nazwisko</td>                                                     
                                                    <td className="">Data urodzenia</td>                                                                                                                                                                                                                                     
                                                    <td className="td_right">Adres</td>                                                                                                                                                                                                                                     
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.map( (item, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                    return <tr className={rowStyle} key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td> 
                                                            <td className="gocenter"> {item.nr_w_dzienniku}</td>                                                                                                                                               
                                                            <td className="goleft"> {item.nazwisko} {item.imie}</td>                                                                                                                                           
                                                            <td className="gocenter">{item.data_urodzenia}</td>                                                                                                                                           
                                                            <td className="goleft">{item.ulica} {item.nr_domu}/{item.nr_mieszkania}, {item.kod_pocztowy} {item.miasto}</td>                                                                                                                                                                                                                                                                                                                                 
                                                          
                                                    </tr>

                                                } )
                                            }

                                        </tbody>

                            </table>


                    </div>




                    <div className="table_widget">                             
                              <InputLegend items={legend}  valChange={valChangeListener} />                        
                    </div>


                          <div className="scorll_x">
          

                            <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Nr w dzienniku</td>                                                                                                                                           
                                                    <td className="">Imię i nazwisko</td>                                                     
                                                    <td className="">Data urodzenia</td>                                                                                                                                                                                                                                     
                                                    <td className="td_right">Adres</td>                                                                                                                                                                                                                                     
                                                    <td className="td_option"></td>                                                                                                                                                                                                                                     
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.map( (item, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                    var cls = "";
                                                    if(item.pokaz == '0') cls = "color_deleted";


                                                    return <tr className={rowStyle + " " + cls} key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                            <td className="gocenter"> {item.nr_w_dzienniku}</td>     
                                                            <td className="goleft"> {item.nazwisko} {item.imie}</td>                                                                                                                                           
                                                            <td className="gocenter">{item.data_urodzenia}</td>                                                                                                                                           
                                                            <td className="goleft">
                                                                {item.ulica} {item.nr_domu}
                                                                {
                                                                    item.nr_mieszkania.length > 0 &&
                                                                    <Fragment>/</Fragment>
                                                                }
                                                                 
                                                                {item.nr_mieszkania}  {item.kod_pocztowy} {item.miasto}</td>                                                                                                                                                                                                                                                                                                                                 

                                                             <MenuTable>
                                                                        <ul>                                                                      
                                                                              {
                                                                                props.status == "aktywny" &&
                                                                                <li onClick={changeView}  id={item.id} v="edit"  >edytuj</li> 
                                                                              }
                                                                                   
                                                                        </ul>                                                               
                                                            </MenuTable>  
                                                          
                                                    </tr>

                                                } )
                                            }

                                        </tbody>

                            </table>
             </div>


             {viewDialog}
             

        </div>
}